import React from 'react';

interface IProps {
  style?: React.CSSProperties;
  children?: React.ReactNode;
}

const Kbd: React.FC<IProps> = props => {
  return (
    <kbd className="kbd" style={props.style}>
      {props.children}
      <style jsx>{`
        .kbd {
          background-color: var(--color-RemoGray05);
          border-radius: 4px;
          display: inline-block;
          margin: 0 2px;
          padding: 0 4px;
          min-width: 20px;
          color: var(--color-RemoGray75);
          text-align: center;
          font-family: var(--font-family-code);
          font-weight: 500;
          font-size: 11px;
          text-transform: capitalize;
          line-height: 20px;
          transition: background-color 0.2s;
        }
        .kbd:hover {
          background-color: var(--color-RemoGray10);
          color: black;
        }
      `}</style>
    </kbd>
  );
};

export default Kbd;
